import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight, X } from 'lucide-react';

import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

export const UpgradeHintCard = ({
  message,
  ctaLabel = 'See what’s coming',
  className = '',
  compact = false,
  onDismiss,
}) => {
  if (!message) return null;

  return (
    <Card className={`border-amber-200 bg-amber-50/80 ${className}`.trim()}>
      <CardContent className={compact ? 'flex items-start gap-3 p-3' : 'flex items-start gap-3 p-4'}>
        <div className="mt-0.5 rounded-full bg-white/80 p-2 text-amber-700">
          <Sparkles className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-amber-950">Coming soon</p>
          <p className="mt-1 text-sm text-amber-900/90">{message}</p>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <Button asChild size="sm" variant="outline" className="border-amber-300 bg-white/90 text-amber-900 hover:bg-white">
              <Link to="/settings/billing">
                {ctaLabel}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            {onDismiss ? (
              <Button type="button" size="sm" variant="ghost" className="text-amber-900/80 hover:text-amber-950" onClick={onDismiss}>
                <X className="mr-1 h-4 w-4" />
                Dismiss
              </Button>
            ) : null}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
